import React from "react";

export const LeftArrowInActive = ({ iconWidth }) => {
  return (
    <div className="left_arrow_icon_disabled">
      <svg
        width={iconWidth}
        height={iconWidth}
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="21"
          cy="21"
          r="20.5"
          transform="matrix(-1 0 0 1 42 0)"
          fill="white"
          stroke="#C5C5C5"
        />
        <path
          d="M22.6464 13.6464C22.8417 13.4512 23.1583 13.4512 23.3536 13.6464C23.5488 13.8417 23.5488 14.1583 23.3536 14.3536L22.6464 13.6464ZM23.3536 14.3536L16.5607 21.1464L15.8536 20.4393L22.6464 13.6464L23.3536 14.3536ZM16.5607 21.8536L23.3536 28.6464L22.6464 29.3536L15.8536 22.5607L16.5607 21.8536ZM16.5607 21.1464C16.3654 21.3417 16.3654 21.6583 16.5607 21.8536L15.8536 22.5607C15.2678 21.9749 15.2678 21.0251 15.8536 20.4393L16.5607 21.1464Z"
          fill="#C5C5C5"
        />
      </svg>
    </div>
  );
};
export const LeftArrowActive = ({ iconWidth }) => {
  return (
    <div className="left_arrow_icon_active">
      <svg
        width={iconWidth}
        height={iconWidth}
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="21"
          cy="21"
          r="20.5"
          transform="matrix(-1 0 0 1 42 0)"
          fill="white"
          stroke="black"
        />
        <path
          d="M22.6464 13.6464C22.8417 13.4512 23.1583 13.4512 23.3536 13.6464C23.5488 13.8417 23.5488 14.1583 23.3536 14.3536L22.6464 13.6464ZM23.3536 14.3536L16.5607 21.1464L15.8536 20.4393L22.6464 13.6464L23.3536 14.3536ZM16.5607 21.8536L23.3536 28.6464L22.6464 29.3536L15.8536 22.5607L16.5607 21.8536ZM16.5607 21.1464C16.3654 21.3417 16.3654 21.6583 16.5607 21.8536L15.8536 22.5607C15.2678 21.9749 15.2678 21.0251 15.8536 20.4393L16.5607 21.1464Z"
          fill="black"
        />
      </svg>
    </div>
  );
};
export const RightArrowInActive = ({ iconWidth }) => {
  return (
    <div className="right_arrow_icon_disabled">
      <svg
        width={iconWidth}
        height={iconWidth}
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="20.5" fill="white" stroke="#C5C5C5" />
        <path
          d="M19.3536 13.6464C19.1583 13.4512 18.8417 13.4512 18.6464 13.6464C18.4512 13.8417 18.4512 14.1583 18.6464 14.3536L19.3536 13.6464ZM18.6464 14.3536L25.4393 21.1464L26.1464 20.4393L19.3536 13.6464L18.6464 14.3536ZM25.4393 21.8536L18.6464 28.6464L19.3536 29.3536L26.1464 22.5607L25.4393 21.8536ZM25.4393 21.1464C25.6346 21.3417 25.6346 21.6583 25.4393 21.8536L26.1464 22.5607C26.7322 21.9749 26.7322 21.0251 26.1464 20.4393L25.4393 21.1464Z"
          fill="#C5C5C5"
        />
      </svg>
    </div>
  );
};
export const RightArrowActive = ({ iconWidth }) => {
  return (
    <div className="right_arrow_icon_active">
      <svg
        width={iconWidth}
        height={iconWidth}
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="20.5" fill="white" stroke="black" />
        <path
          d="M19.3536 13.6464C19.1583 13.4512 18.8417 13.4512 18.6464 13.6464C18.4512 13.8417 18.4512 14.1583 18.6464 14.3536L19.3536 13.6464ZM18.6464 14.3536L25.4393 21.1464L26.1464 20.4393L19.3536 13.6464L18.6464 14.3536ZM25.4393 21.8536L18.6464 28.6464L19.3536 29.3536L26.1464 22.5607L25.4393 21.8536ZM25.4393 21.1464C25.6346 21.3417 25.6346 21.6583 25.4393 21.8536L26.1464 22.5607C26.7322 21.9749 26.7322 21.0251 26.1464 20.4393L25.4393 21.1464Z"
          fill="black"
        />
      </svg>
    </div>
  );
};
export const RightArrow = () => {
  return (
    <>
      <svg
        width="9"
        height="17"
        viewBox="0 0 9 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L1.35355 0.646447ZM0.646447 1.35355L7.43934 8.14645L8.14645 7.43934L1.35355 0.646447L0.646447 1.35355ZM7.43934 8.85355L0.646447 15.6464L1.35355 16.3536L8.14645 9.56066L7.43934 8.85355ZM7.43934 8.14645C7.6346 8.34171 7.6346 8.65829 7.43934 8.85355L8.14645 9.56066C8.73223 8.97487 8.73223 8.02513 8.14645 7.43934L7.43934 8.14645Z"
          fill="black"
        />
      </svg>
    </>
  );
};
export const LeftArrowNavigate = () => {
  return (
    <>
      <svg
        width="6"
        height="10"
        viewBox="0 0 6 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.78933 9.35355C4.98459 9.54882 5.30117 9.54882 5.49644 9.35355C5.6917 9.15829 5.6917 8.84171 5.49644 8.64645L4.78933 9.35355ZM1.56428 4.00718L1.21072 3.65363L1.21072 3.65363L1.56428 4.00718ZM5.49644 8.64645L1.91783 5.06784L1.21072 5.77495L4.78933 9.35355L5.49644 8.64645ZM1.91783 4.36073L5.49644 0.782126L4.78933 0.0750179L1.21072 3.65363L1.91783 4.36073ZM1.91783 5.06784C1.72257 4.87258 1.72257 4.55599 1.91783 4.36073L1.21072 3.65363C0.624937 4.23941 0.624936 5.18916 1.21072 5.77495L1.91783 5.06784Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export const FillStar = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1757 1.53678C10.4352 0.73831 11.5648 0.738308 11.8242 1.53678L13.7241 7.38393C13.8401 7.74101 14.1729 7.98278 14.5484 7.98278H20.6964C21.536 7.98278 21.885 9.05711 21.2058 9.55059L16.2319 13.1643C15.9282 13.385 15.8011 13.7762 15.9171 14.1333L17.817 19.9804C18.0764 20.7789 17.1625 21.4429 16.4833 20.9494L11.5094 17.3357C11.2057 17.115 10.7943 17.115 10.4906 17.3357L5.51671 20.9494C4.83749 21.4429 3.9236 20.7789 4.18304 19.9804L6.08289 14.1333C6.19892 13.7762 6.07182 13.385 5.76806 13.1643L0.794179 9.55059C0.11496 9.05711 0.464031 7.98278 1.30359 7.98278H7.45165C7.82711 7.98278 8.15987 7.74101 8.2759 7.38393L10.1757 1.53678Z"
          fill="black"
        />
      </svg>
    </>
  );
};
export const EmptyStar = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1757 1.53678C10.4352 0.73831 11.5648 0.738308 11.8242 1.53678L13.7241 7.38393C13.8401 7.74101 14.1729 7.98278 14.5484 7.98278H20.6964C21.536 7.98278 21.885 9.05711 21.2058 9.55059L16.2319 13.1643C15.9282 13.385 15.8011 13.7762 15.9171 14.1333L17.817 19.9804C18.0764 20.7789 17.1625 21.4429 16.4833 20.9494L11.5094 17.3357C11.2057 17.115 10.7943 17.115 10.4906 17.3357L5.51671 20.9494C4.83749 21.4429 3.9236 20.7789 4.18304 19.9804L6.08289 14.1333C6.19892 13.7762 6.07182 13.385 5.76806 13.1643L0.794179 9.55059C0.11496 9.05711 0.464031 7.98278 1.30359 7.98278H7.45165C7.82711 7.98278 8.15987 7.74101 8.2759 7.38393L10.1757 1.53678Z"
          fill="#C1C1C1"
        />
      </svg>
    </>
  );
};

export const LoveReactIcon = ({color="white",iconWidth}) => {
  return (
    <div>
      <svg
        width={iconWidth}
        height={iconWidth}
        viewBox="0 0 32 32"
        fill="red"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1333 24.7333L16 24.8667L15.8533 24.7333C9.51996 18.9867 5.33329 15.1867 5.33329 11.3333C5.33329 8.66667 7.33329 6.66667 9.99996 6.66667C12.0533 6.66667 14.0533 8 14.76 9.81333H17.24C17.9466 8 19.9466 6.66667 22 6.66667C24.6666 6.66667 26.6666 8.66667 26.6666 11.3333C26.6666 15.1867 22.48 18.9867 16.1333 24.7333ZM22 4C19.68 4 17.4533 5.08 16 6.77333C14.5466 5.08 12.32 4 9.99996 4C5.89329 4 2.66663 7.21333 2.66663 11.3333C2.66663 16.36 7.19996 20.48 14.0666 26.7067L16 28.4667L17.9333 26.7067C24.8 20.48 29.3333 16.36 29.3333 11.3333C29.3333 7.21333 26.1066 4 22 4Z"
          fill={color}
         fillOpacity="0.4"
        />
      </svg>
    </div>
  );
};


export const CheckMark = ()=>{
  <svg xmlns="http://www.w3.org/2000/svg" width="67.637" height="67.637" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 1778.69 1778.68" id="check"><path fill-rule="nonzero" d="M1254.85 558.21c28.97,-28.97 75.96,-28.97 104.93,0 28.97,28.98 28.97,75.97 0,104.94l-557.28 557.3c-28.98,28.97 -75.97,28.97 -104.94,0l-278.65 -278.65c-28.97,-28.97 -28.97,-75.96 0,-104.93 28.98,-28.98 75.97,-28.98 104.94,0l226.18 226.18 504.82 -504.84zm-365.51 -558.21c245.55,0 467.91,99.56 628.85,260.5 160.94,160.93 260.5,383.3 260.5,628.84 0,245.58 -99.55,467.91 -260.5,628.85 -160.94,160.94 -383.3,260.5 -628.85,260.5 -245.57,0 -467.91,-99.55 -628.84,-260.5 -160.96,-160.94 -260.5,-383.27 -260.5,-628.85 0,-245.54 99.56,-467.91 260.5,-628.84 160.93,-160.96 383.27,-260.5 628.84,-260.5zm523.92 365.43c-134.07,-134.06 -319.31,-216.99 -523.92,-216.99 -204.62,0 -389.86,82.93 -523.91,216.99 -134.06,134.06 -216.99,319.31 -216.99,523.91 0,204.63 82.93,389.87 216.99,523.92 134.05,134.06 319.29,216.98 523.91,216.98 204.61,0 389.85,-82.92 523.92,-216.98 134.06,-134.05 216.98,-319.29 216.98,-523.92 0,-204.6 -82.92,-389.85 -216.98,-523.91z"></path></svg>
}
